import { render, staticRenderFns } from "./NuevoRecibo.vue?vue&type=template&id=708b33fb&scoped=true"
import script from "./NuevoRecibo.vue?vue&type=script&lang=js"
export * from "./NuevoRecibo.vue?vue&type=script&lang=js"
import style0 from "./NuevoRecibo.vue?vue&type=style&index=0&id=708b33fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b33fb",
  null
  
)

export default component.exports